import React, { useState, useContext, useEffect, useRef } from 'react'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import { handleRedirectInternal } from '../../common/components'
import { useHistory, NavLink } from 'react-router-dom'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import './Home1.css'
import { logo, siteName } from '../../Utils'
import {
    Badge,
    Button,
    Divider,
    Drawer,
    ListItem,
    Menu,
    MenuItem,
    SwipeableDrawer,
} from '@material-ui/core'
import CommonContext from '../../context/common/commonContext'
import GridView from '../../components/molecules/ProductCard/GridView'
import Search from '../Search'
import { Pagination } from '@material-ui/lab'
import ListView from '../../components/molecules/ProductCard/ListView'
import Loader from '../../components/molecules/Loader'
import ProductContext from '../../context/product/productContext'
import authContext from '../../context/auth/authContext'

function Home1() {
    const history = useHistory()
    const productContext = useContext(ProductContext)
    const { isAuthenticated } = useContext(authContext)
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
    }
    let [viewProduct, setViewProduct] = useState([])
    const {
        search_allproducts,
        getAllSearchProducts,
        responseStatus,
        getProjectsMain,
        projectsMain,
        getProjectsCompleted,
        projectCompleted,
        dispatchSelectedCategories,
        selectedCategories,
        projmainloading,
    } = productContext
    const { language, phrase, getLangPhrase } = useContext(CommonContext)

    useEffect(() => {
        getLangPhrase(language)
    }, [language])

    useEffect(() => {
        getAllSearchProducts({}, 'search')
    }, [])

    useEffect(() => {
        setViewProduct(search_allproducts)
    }, [search_allproducts])

    return (
        <div className="content-wrapper">
            <section className="wrapper image-wrapper">
                <div className="container content">
                    <div className="row">
                        <div className="col-lg-8 col-xl-7 col-xxl-6 text-left">
                            <h1 className="wholesale text-white">KEYSTONE AUCTIONS</h1>
                            {/* <p className="lead fs-24 text-white lh-sm mb-7 mx-md-13 mx-lg-10">
                                Worldwide desktop computers and components bidding platform
                            </p> */}
                            <Button className="readmore mt-4">
                                <NavLink to={!isAuthenticated ? '/login' : '/search'} className="">
                                    Login to Bid
                                </NavLink>
                            </Button>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className="wrapper bg-light auctions pb-5">
                <div className="inner-container">
                    <h2 className="mb-3">Our Auctions</h2>
                    <div>
                        {projmainloading ? (
                            <Loader />
                        ) : viewProduct.length ? (
                            <>
                                <div className={`searchResults ${auctionView}`}>
                                    

                                    {viewProduct.map((data, index) => (
                                        <React.Fragment key={index}>
                                            {auctionView === 'Grid' ? (
                                                <>
                                                    <GridView
                                                        data={data}
                                                        favId={`searchProd_${index}`}
                                                        // drawerHandler={toggleDrawer(
                                                        //     'right',
                                                        //     true,
                                                        //     data,
                                                        // )}
                                                    />
                                                </>
                                            ) : (
                                                <ListView
                                                    data={data}
                                                    favId={`searchProd_${index}`}
                                                    // drawerHandler={toggleDrawer(
                                                    //     'right',
                                                    //     true,
                                                    //     data,
                                                    // )}
                                                />
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>

                                <div className="d-flex justify-content-between align-items-center flex-wrap w-100 my-3 pagination-wrapper">
                                    <Pagination
                                        count={Math.ceil(
                                            projectsMain.totalRecords /
                                                projectsMainPayload.sh_limit,
                                        )}
                                        page={projectsMainPayload.page}
                                        onChange={onHandlePage}
                                        siblingCount={3}
                                        showFirstButton
                                        showLastButton
                                        boundaryCount={2}
                                    />
                                </div>
                            </>
                        ) : (
                            <div className="np-pro-box">
                                <h5>{phrase.no_results_found}!</h5>
                            </div>
                        )}
                    </div>
                </div>
            </section> */}
            <section className="wrapper ading p-5">
                <div className="twoBidds">
                    <NavLink className="leftBidd" to={'/search'}>
                        <h1>Explore Our Latest Auctions Today.</h1>
                    </NavLink>
                    <NavLink className="rightBidd" to={'/search'}>
                        <h1>Join Our Mobile Auction Experience Now.</h1>
                    </NavLink>
                </div>
            </section>
            <section className="wrapper computers py-5">
                <div className="inner-container py-5">
                    <h1 className="whyChooseUs mb-4">Why Choose Us</h1>
                    {/* <p className="whyChoosePara my-4">
                        Lorem Ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius
                        enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros
                        dolor interdum nulla, ut commondo diam libero vitae erat.
                    </p> */}
                    <div className="comp_parts mt-5">
                        <div>
                            <div className="part mb-5">
                                <span>
                                    <img
                                        src="/assets/images/rotatingInventory.png"
                                        alt="Rotating Inventory"
                                    />
                                </span>
                                <h3>Rotating Inventory</h3>
                                <p>
                                    Our inventory changes monthly, check back regularly to see our
                                    latest auctions.
                                </p>
                            </div>
                            <div className="part">
                                <span>
                                    <img src="/assets/images/certified.png" alt="Certified" />
                                </span>
                                <h3>Certified</h3>
                                <p>
                                    Bid with confidence! We are R2v3, ISO 45001, ISO 9001 and ISO
                                    14001 Certified.
                                </p>
                            </div>
                        </div>
                        <div>
                            <div className="part mb-5">
                                <span>
                                    <img
                                        src="/assets/images/respected.png"
                                        alt="Respected-In-Industry"
                                    />
                                </span>
                                <h3>Respected in the Industry</h3>
                                <p>
                                    Executive Sales Team each has over 20 plus years experience in
                                    the ITAD and used computer industry.
                                </p>
                            </div>
                            <div className="part">
                                <span>
                                    <img
                                        src="/assets/images/knowledgeable.png"
                                        alt="Knowledgeable"
                                    />
                                </span>
                                <h3>Knowledgeable</h3>
                                <p>
                                    The extensive years of experience guarantee the quality of your
                                    purchase, providing you with peace of mind.
                                </p>
                            </div>
                        </div>
                        <div>
                            <div className="part mb-5">
                                <span>
                                    <img
                                        src="/assets/images/liveAuctions.png"
                                        alt="Live Auctions"
                                    />
                                </span>
                                <h3>Live Auctions</h3>
                                <p>
                                    Know you&apos;re getting the best deal with our live bidding
                                    platform.
                                </p>
                            </div>
                            <div className="part">
                                <span>
                                    <img src="/assets/images/experienced.png" alt="Experienced" />
                                </span>
                                <h3>Experienced Global Shippers</h3>
                                <p>
                                    All lots are professionally packed for safe international
                                    transport as arranged by the winning bidder.
                                </p>
                            </div>
                        </div>

                        {/* <div className="part">
                            <span className="material-icons">computer</span>
                            <h3>Computer Built Request</h3>
                            <p>
                                We are more than happy to assist your needs, so we&apos;ll build
                                computer systems with the specifications you want.
                            </p>
                        </div> */}

                        {/* <div className="part">
                            <span className="material-icons">cast</span>
                            <h3>Warranty</h3>
                            <p>
                                All our products are covered by warranty, depending on the
                                product&apos;s type, category and condition
                            </p>
                        </div> */}
                    </div>
                </div>
            </section>
            {/* <section className="wrapper bg-pink">
                <div className="container py-15 py-md-17 pb-md-19">
                    <h6 className="world mb-3">18 YEARS OF EXPERIENCE</h6>
                    <h2 className="mb-5">
                        Keystone is a global wholesale distributor of refurbished and used desktop
                        computers equipment and components.
                    </h2>
                    <div className="card shadow-lg">
                        <div className="row gx-0">
                            <div className="col-lg-6">
                                <div className="bg-image bg-cover rounded-top rounded-lg-start new-image"></div>
                            </div>
                            <div className="col-lg-6">
                                <div className="p-5">
                                    <h3 className="my-4">Welcome to Keystone</h3>
                                    <p>
                                        Your source for used and refurbished Desktop Computers & All
                                        in Ones Systems. In addition to used wholesale computers, we
                                        sell computer parts such as CPUs, RAMs, HDDs, SSDs, GPUs,
                                        Motherboards, Optical Drives, Power Supplies, Power
                                        Adapters, e.t.c.
                                    </p>
                                    <Button className="readmore my-4">
                                        <NavLink to="/about" className="text-white">
                                            Read More
                                        </NavLink>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
        </div>
    )
}

export default Home1
